export default __webpack_public_path__ + "static/media/285.9d30306b.png";